export const selectSubjectList = ({ CategoryStore }) => CategoryStore.subjects;
export const selectSystemList = ({ CategoryStore }) => CategoryStore.systems;
export const selectCategoriesRequestStatus = ({ CategoryStore }) =>
  CategoryStore.requestStatus;
